"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useThemeDefaultProps;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _styles = require("@material-ui/core/styles");

/* eslint-disable @typescript-eslint/no-explicit-any */
function useThemeDefaultProps(name, props, defaultTheme) {
  return typeof name === 'string' && name ? function () {
    // name and withTheme are invariant in the outer scope
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var theme = (0, _styles.useTheme)() || defaultTheme;
    return Object.entries((theme.props || {})[name] || {}).reduce(function (r, _ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];

      return r[k] === undefined ? (0, _extends3.default)({}, r, (0, _defineProperty2.default)({}, k, v)) : r;
    }, props);
  }() : props;
}